import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';

const propTypes = {
    className: PropTypes.string,
    onClick: PropTypes.func,
    iconPath: PropTypes.string,
    text: PropTypes.string,
    href: PropTypes.string,
    iconClass: PropTypes.string,
    textClass: PropTypes.string,
};

const defaultProps = {
    className: '',
    onClick: null,
    iconPath: '',
    text: 'action',
    href: '',
    iconClass: '',
    textClass: '',
    iconStyle: undefined
};

function AccessButton({ className, onClick, iconPath, text, href, iconClass, textClass, iconStyle }) {
        function _onClick(e) {
            if (onClick) {
                onClick();
            }
        }

        let icon = null;
        if (iconPath) {
            icon = <img src={iconPath} aria-hidden="true" style={iconStyle}/>;
        }
        else if (iconClass) {
            icon = <i className={iconClass} aria-hidden="true"/>;
        }

        if (!!href) {
            return (
              <div className={`access-button ${className}`}>
                    <Link className="link-plain" to={href}> {icon} <span className={"icon-label action-label" + (textClass ? (' ' + textClass) : '')}>{text}</span></Link>
                </div>
            );
        }
        else {
            return (
                <div className={`access-button ${className}`}>
                    <a className="link-plain" href="#" onClick={_onClick}> {icon} <span className="icon-label action-label">{text}</span></a>
                </div>
            );
        }
}

AccessButton.propTypes = propTypes;
AccessButton.defaultProps = defaultProps;

export default AccessButton;